import { AdvancedMarker } from '@vis.gl/react-google-maps'
import { MapMarker } from '@asad/ui'

const MapMarkers = ({ devicesStatuses, clickedChip, visibleDevices, onPinClick }) => {
  return (
    <>
      {visibleDevices?.map(({ id, latitude, longitude, name }) => {
        const hasCoords = latitude !== undefined && latitude !== null

        return hasCoords ? (
          <AdvancedMarker
            key={id}
            position={{
              lat: latitude,
              lng: longitude,
            }}
            onClick={() => {
              if (onPinClick) {
                onPinClick(id)
              }
            }}
            zIndex={id === clickedChip ? 9999 : 1}
          >
            <MapMarker
              deviceName={name}
              deviceStatus={devicesStatuses.find((status) => status.id === id)}
              isClicked={id === clickedChip}
            />
          </AdvancedMarker>
        ) : null
      })}
    </>
  )
}

export default MapMarkers
